import { ajaxService } from '../../common/Services';
import { ApiUtils } from '../../common/api';
import Model from './blacklist-model';

//[Victor] This is saved as part of the blacklist modal in account settingsand is NOT submitted along with the account model
//it uses current account session of the BE to determin which account id this blacklist update associates to
function updateBlacklist(blacklist) {
  return ajaxService
    .post('/api/advocacy/update.json', Model.serialize(blacklist))
    .then(ApiUtils.validate)
    .then(ApiUtils.extract1)
    .then(Model.deserialize)
    .catch(error => ({ error }));
}

export default {
  updateBlacklist,
};
